import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import './index.styl'

const InstitutionalInvestorsConference = ({ pageData, activeCat }) => {
  const { t } =  useTranslation()
  const [list, setList] = useState([])

  useEffect(() => {
  	setList(pageData.reverse())
  }, [])

  return (
    <div className="institutional-investors-conference investor__main">
      <h2 className="investor__title">{t(`nav_${activeCat}`)}</h2>
      {
      	list.map(d => (
          <table className="investor__table" key={d._id}>
            <thead className="investor__table-thead">
              <tr className="investor__table-tr">
                <th className="investor__table-th" colspan="2">{d.title}</th>
              </tr>
            </thead>
           	<tbody>
           	  <tr className="investor__table-tr investor__table-tr--odd">
           	  	<td className="investor__table-td investor__table-td--50">
           	  		<a href={`https://www.duro.com.tw:8088/api/v1.0/institutional_investors_conference_pdf/${d.file1}`} target="_blank">{t('institutionalInvestorsConference.chinese_briefing')}</a>
           	  	</td>
           	  	<td className="investor__table-td investor__table-td--50">
           	  		<a href={`https://www.duro.com.tw:8088/api/v1.0/institutional_investors_conference_pdf/${d.file2}`} target="_blank">{t('institutionalInvestorsConference.english_briefing')}</a>
           	  	</td>
           	  </tr>
           	</tbody>
          </table>
      	))
      }
    </div>
  )
}

InstitutionalInvestorsConference.propTypes = {}

export default InstitutionalInvestorsConference
